import { Flow, Text } from 'bold-ui'

interface HistoricoMChatSimpleHorizontalTableItemProps {
  pergunta: string | undefined
  resposta: string | undefined | null
}

export const HistoricoMChatSimpleHorizontalTableItem = (
  props: Readonly<HistoricoMChatSimpleHorizontalTableItemProps>
) => {
  const { pergunta, resposta } = props

  if (pergunta === undefined) return null
  const hasResposta = resposta !== undefined && resposta !== null

  return (
    <Flow direction='horizontal' gap={0.5} justifyItems='stretch'>
      <Text heading={4} fontWeight='bold'>
        {pergunta}
      </Text>
      {hasResposta && <Text heading={4}>{resposta}</Text>}
    </Flow>
  )
}
